
<image-container-card
  as="a"
  v-bind="$attrs"
  v-on="$listeners"
  :image="item.thumbnail || item.image"
>
  <align justify="space-between">
    <div class="platform-text">{{ item.platform }}</div>

    <countdown-timer
      v-if="item.endDate && item.listingType === 'Auction'"
      :end-time="item.endDate"
    />
  </align>

  <div class="item-text">{{ item.title }}</div>

  <align direction="flex-end" justify="space-between">
    <card-stat-item
      :card="item"
      stat="price"
    />

    <div class="extra-info" v-if="item.bids != null || item.watchers != null || item.listingType === 'Best Offer'">
      <span v-if="item.bids != null">Bids: {{ item.bids }}</span>
      <span v-if="item.watchers != null">Watchers: {{ item.watchers }}</span>
      <span v-if="item.listingType === 'Best Offer'">or Best Offer</span>
    </div>
  </align>
</image-container-card>
